import { render } from "./user_agreement.vue?vue&type=template&id=fe72b65c&scoped=true"
import script from "./user_agreement.vue?vue&type=script&lang=js"
export * from "./user_agreement.vue?vue&type=script&lang=js"

import "./user_agreement.vue?vue&type=style&index=0&id=fe72b65c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe72b65c"]])

export default __exports__